export const getUsers = (successCallback, errorCallback) => {
  return fetch(`/api/v2/super_users/users`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
  })
    .then(async (response) => {
      const contentType = response.headers.get('content-type') || '';
      const data = contentType.includes('application/json') ? await response.json() : null;

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${data?.error || data?.message || 'Request failed'}`);
      }

      if (!data) {
        throw new Error('Invalid users response');
      }

      return data;
    })
    .then((data) => {
      if (successCallback) {
        successCallback(data);
      }
      return data;
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback(error);
      }
      throw error; // Re-throw so promise consumers can still handle it
    });
};

export const getUserDirectory = ({ accountUuid, query } = {}) => {
  const params = new URLSearchParams();
  if (accountUuid) params.set('account_uuid', accountUuid);
  if (query) params.set('query', query);

  const queryString = params.toString();
  const url = `/api/v2/super_users/users/directory${queryString ? `?${queryString}` : ''}`;

  return fetch(url, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
  }).then(async (response) => {
    const data = await response.json();
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${data?.error || data?.message || 'Request failed'}`);
    }
    return data;
  });
};
